/** The query flag that makes the wizard ignore the stored session and start a new one. */
export const FRESH_SESSION_PARAM = 'nreg'

/**
 * The query string of the wizard opened on a NEW session, keeping everything else
 * the query carries (a `?team_id=` link, say). The stored session is left as it is.
 */
export const withFreshSession = (search: string): string => {
  const params = new URLSearchParams(search)
  params.set(FRESH_SESSION_PARAM, '1')

  return `?${params.toString()}`
}
